"use strict";
window.theme = window.theme || {};
theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
    $(document)
        .on("shopify:section:load", this._onSectionLoad.bind(this))
        .on("shopify:section:unload", this._onSectionUnload.bind(this))
        .on("shopify:section:select", this._onSelect.bind(this))
        .on("shopify:section:deselect", this._onDeselect.bind(this))
        .on("shopify:block:select", this._onBlockSelect.bind(this))
        .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
};
theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
    _createInstance: function _createInstance(container, constructor) {
        var $container = $(container);
        var id = $container.attr("data-section-id");
        var type = $container.attr("data-section-type");
        constructor = constructor || this.constructors[type];
        if (_.isUndefined(constructor)) {
            return;
        }
        var instance = _.assignIn(new constructor(container), { id: id, type: type, container: container });
        this.instances.push(instance);
    },
    _onSectionLoad: function _onSectionLoad(evt) {
        var container = $("[data-section-id]", evt.target)[0];
        if (container) {
            this._createInstance(container);
        }
    },
    _onSectionUnload: function _onSectionUnload(evt) {
        this.instances = _.filter(this.instances, function (instance) {
            var isEventInstance = instance.id === evt.detail.sectionId;
            if (isEventInstance) {
                if (_.isFunction(instance.onUnload)) {
                    instance.onUnload(evt);
                }
            }
            return !isEventInstance;
        });
    },
    _onSelect: function _onSelect(evt) {
        var instance = _.find(this.instances, function (instance) {
            return instance.id === evt.detail.sectionId;
        });
        if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
            instance.onSelect(evt);
        }
    },
    _onDeselect: function _onDeselect(evt) {
        var instance = _.find(this.instances, function (instance) {
            return instance.id === evt.detail.sectionId;
        });
        if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
            instance.onDeselect(evt);
        }
    },
    _onBlockSelect: function _onBlockSelect(evt) {
        var instance = _.find(this.instances, function (instance) {
            return instance.id === evt.detail.sectionId;
        });
        if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
            instance.onBlockSelect(evt);
        }
    },
    _onBlockDeselect: function _onBlockDeselect(evt) {
        var instance = _.find(this.instances, function (instance) {
            return instance.id === evt.detail.sectionId;
        });
        if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
            instance.onBlockDeselect(evt);
        }
    },
    register: function register(type, constructor) {
        this.constructors[type] = constructor;
        $("[data-section-type=" + type + "]").each(
            function (index, container) {
                this._createInstance(container, constructor);
            }.bind(this)
        );
    },
});
window.slate = window.slate || {};
window.theme = window.theme || {};
theme.ajaxCart = (function () {
    var selectors = {
        body: "body",
        cartAjaxMobile: "ajax-cart--open--noscroll",
        siteHeader: ".site-header--wrapper",
        cartToggleBtn: ".site-header__cart--toggle",
        cartPanel: ".cart-ajax",
        cartTools: ".cart-ajax__tools",
        activeClass: "cart-ajax--show",
        cartClose: ".cart-ajax__close",
        headerWrapper: ".site-header--wrapper",
        hoverHeaderWrapper: "site-header--hover",
        notificationBar: ".notification-bar",
    };
    var cache = {
        $body: $(selectors.body),
        $cartPanel: $(selectors.cartPanel),
        $cartClose: $(selectors.cartClose),
        $headerWrapper: $(selectors.headerWrapper),
        $cartTools: $(selectors.cartTools),
        $notificationBar: $(selectors.notificationBar),
    };
    function init() {
        if (!$(selectors.siteHeader).length) {
            return;
        }
        $(selectors.cartToggleBtn).on("click", _toggleCartPanel.bind(this));
        $(cache.$cartClose).on("click", _closeCartPanel.bind(this));
        $(document).on("AjaxCartRequest AjaxCartModify", _updateCartModal.bind(this));
        $(document).on("updateCart", _ajaxCartUpdateCart.bind(this));
        updateAjaxCartHeight();
        window.addEventListener("scroll", updateAjaxCartHeight, false);
        window.addEventListener("resize", updateAjaxCartHeight, false);      
    }
    var updateAjaxCartHeight = function updateAjaxCartHeight() {
        cache.$cartPanel.css({ height: "calc(100vh - " + cache.$headerWrapper.outerHeight() + "px)" });
        if ($(".site-header--wrapper").hasClass("site-header--going-up") || $(".site-header--wrapper").hasClass("site-header--going-up--mobile")) {
            cache.$cartPanel.css({ height: "calc(100vh - " + $(".site-header__main").outerHeight() + "px)" });
        }
    };
    function _requestCartEvent(evt) {
        evt.preventDefault();
        var evtTarget = evt.target;
        $(document).trigger({ type: "AjaxCartRequest", target: evtTarget });
    }
    function _openCartPanel(e) {
        _setWindowEvents();
        cache.$cartPanel.addClass(selectors.activeClass);
        cache.$headerWrapper.addClass(selectors.hoverHeaderWrapper);
        cache.$body.addClass(selectors.cartAjaxMobile);
        updateAjaxCartHeight();
    }
    function _closeCartPanel() {
        cache.$cartPanel.removeClass(selectors.activeClass);
        cache.$headerWrapper.removeClass(selectors.hoverHeaderWrapper);
        cache.$body.removeClass(selectors.cartAjaxMobile);
        _removeWindowEvents();
    }
    function _toggleCartPanel(evt) {
        evt.preventDefault();
        if (window.location.href.indexOf("/cart") > -1) {
            location.reload();
        } else {
            if (cache.$cartPanel.hasClass(selectors.activeClass)) {
                _closeCartPanel();
            } else {
                _openCartPanel();
                _requestCartEvent(evt);
            }
        }
    }
    function _updateCartModal(evt) {

        var url = "/cart.js";
        var evtType = evt.type;
        var selectors = {
            form: ".product-form",
            cartCount: "#CartCount",
            cartSubmitBtn: ".product-form__cart-submit span",
            cartBody: ".cart-ajax",
            cartList: ".cart-ajax__list",
            cartRow: ".cart-ajax__row",
            cartRemove: ".cart-ajax__remove",
            cartQuantity: ".cart-ajax__quantity-ico",
            cartTotalPrice: ".cart-ajax--total-price",
            cartCheckoutBtn: '[href="/checkout"]',
            cartOpened: false,
            quickViewClose: ".modaal-close",
        };
        $(document).find(selectors.quickViewClose).trigger("click");
        if (evtType == "AjaxCartModify") {
            var updatedVariant = evt.variantIDUpdated;
            var updatedQuantity = evt.variantQuantityUpdated;
            var updatedTotalPrice = evt.response.total_price;
            var updatedTotal = evt.response.item_count;
            if (updatedQuantity == 0) {
                var rowToDelete = selectors.cartRow + '[data-variant="' + updatedVariant + '"]';
                $(rowToDelete).addClass("cart-ajax__row--deleted");
                setTimeout(function () {
                    $(rowToDelete).remove();
                }, 150);
            }
            var cartTotal = updatedTotal;
            cartTotal > 0 ? $(selectors.cartCount).addClass("site-header__cart-count--show") : $(selectors.cartCount).removeClass("site-header__cart-count--show");
            $(selectors.cartCount).find("span").html(cartTotal);
            if (cartTotal <= 0) {
                $(selectors.cartList).html('<p class="text-left">' + theme.strings.cartEmpty + "</p>");
                $(selectors.cartCheckoutBtn).hide();
            } else {
                $(selectors.cartCheckoutBtn).show();
            }
            $(selectors.cartTotalPrice).html("<span class=money>" + theme.Currency.formatMoney(updatedTotalPrice, currencyFormat.shopifyMoneyFormat) + "</span>");
            $(document).trigger({ type: "AjaxCartUpdated" });
        } else if (evtType == "AjaxCartRequest") {
            $.getJSON(url, function (data) {
                console.log(data);
                var items = data.items;
                var cartTotal = data.item_count;
                cartTotal > 0 ? $(selectors.cartCount).addClass("site-header__cart-count--show") : $(selectors.cartCount).removeClass("site-header__cart-count--show");
                $(selectors.cartCount).find("span").html(cartTotal);
                if (cartTotal <= 0) {
                    $(selectors.cartList).html(theme.strings.cartEmpty);
                } else {
                    $(selectors.cartList).html("");
                    $(selectors.cartCheckoutBtn).show();
                }





                items.forEach(function (item, i) {
console.log(item);
                    var cartRemoveHtml, groupId;
                    var groupItem = false,
                        propertySize = 0;

                    if(item.properties) {
                        propertySize = Object.keys(item.properties).length;
                    }


                    if(propertySize > 0) {
                        for(var property in item.properties) {
                            if(property == 'group_id') {
                                groupId = item.properties[property].toString();;
                                groupItem = true;
                            }
                        }
                    }



                    if(groupItem == true) {

                        cartRemoveHtml = '\
                                        <span id="remove__' + item.variant_id + '" class="cart-ajax__remove" style="cursor: pointer;" onclick="removeGroup(' + groupId + ', ' + item.variant_id + ')">\
                                            <img class="cart-ajax__remove-icon" src="' + theme.assets.iconClose + '">\
                                        </span>\
                        ';
                    }
                    else {
                        cartRemoveHtml = '\
                                        <a href="/cart/change?line=' + (i + 1) + '&quantity=0" class="cart-ajax__remove">\
                                            <img class="cart-ajax__remove-icon" src="' + theme.assets.iconClose + '">\
                                        </a>\
                        ';
                    }


                    var cartVariantTitle = item.variant_title != null ? item.variant_title : "",
                        cartImage =
                            '<a href="' + item.url + '">\n                        <div class="cart-ajax__image">\n                          <img src="' + item.image + '"/>\n                        </div>\n                      </a>',
                        cartTitle =
                            '<a href="' +
                            item.url +
                            '">\n                          <div class="grid-view-item__title">' +
                            item.product_title +
                            '</div>\n                          <p class="grid-view-item__variant">' +
                            cartVariantTitle +
                            "</p>\n                       </a>",
                        cartPrice = '<p class="cart-ajax__price"><span class=money>' + theme.Currency.formatMoney(item.price, currencyFormat.shopifyMoneyFormat) + "</span><p>",
                        cartRemove = cartRemoveHtml,
                        cartQuantity =
                            '<div class="cart-ajax__quantity item-quantity">\n                            <div class="item-quantity--input-wrapper">' +
                            theme.strings.cartQuantity +
                            (": " + item.quantity + "</div>\n                            " + cartRemove + "\n                          </div>"),
                        cartData =
                            '<div class="cart-ajax__row" data-variant="' +
                            item.variant_id +
                            '">\n                        <div class="cart-ajax__data">\n                          <div class="grid__item medium-up--one-half medium-down--one-half">' +
                            cartImage +
                            '</div>\n                          <div class="grid__item medium-up--one-half medium-down--one-half">' +
                            (cartTitle + cartQuantity + cartPrice) +
                            "</div>\n                        </div>\n                      </div>";
                    $(selectors.cartList).append(cartData);
                });
                $(selectors.cartTotalPrice).html("<span class=money>" + theme.Currency.formatMoney(data.total_price, currencyFormat.shopifyMoneyFormat) + "</span>");
            }).done(function () {
                $(document).trigger("updateCurrencies");
                _openCartPanel();
            });
            $(document).trigger({ type: "AjaxCartUpdated" });
        }
    }

    function _ajaxCartUpdateCart(evt) {
        var variantQuantity = parseInt(evt.quantity),
            variantID = evt.variant,
            inputType = $(evt.inputType).prop("class"),
            updateData = { updates: {} };
        if (inputType.includes("plus")) {
            variantQuantity = variantQuantity + 1;
        }
        if (inputType.includes("minus")) {
            variantQuantity = variantQuantity - 1;
        }
        if (inputType.includes("remove")) {
            variantQuantity = 0;
        }
        updateData.updates[variantID] = variantQuantity;
        $.ajax({
            type: "POST",
            url: "/cart/update.js",
            data: updateData,
            dataType: "json",
            success: function success(cartData) {
                $(document).trigger({ type: "AjaxCartModify", response: cartData, variantIDUpdated: variantID, variantQuantityUpdated: variantQuantity });
            },
            error: function error(request) {
                var error = JSON.parse(request.responseText);
                alert(error.message + ": " + error.description + ". Contact customer support if error continues: " + theme.strings.shopEmail);
            },
        });
        evt.preventDefault();
    }
    function _setWindowEvents() {
        $(document).on("mouseup touchend AjaxCartModalClose", function (e) {
            if (_isClickOutsideContainer(e) || e.type === "AjaxCartModalClose") {
                _closeCartPanel();
            }
        });
    }
    function _removeWindowEvents() {
        $(document).off("mouseup touchend AjaxCartModalClose");
    }
    function _isClickOutsideContainer(e) {
        return $(e.target).parents(selectors.cartToggleBtn).length === 0 && !$(e.target).parents(selectors.cartPanel).is($(selectors.cartPanel));
    }
    return { init: init, updateAjaxCartHeight: updateAjaxCartHeight };
})();
$(".shogun-table-column").each(function () {
    if ($.trim($(this).html()).length == 0) {
        $(this).css("padding", 0);
    }
});
theme.Drawers = (function () {
    function Drawer(id, position, options) {
        var defaults = { close: ".js-drawer-close", open: ".js-drawer-open-" + position, openClass: "js-drawer-open", dirOpenClass: "js-drawer-open-" + position };
        this.nodes = { $parent: $("html").add("body"), $page: $("#PageContainer") };
        this.config = $.extend(defaults, options);
        this.position = position;
        this.$drawer = $("#" + id);
        if (!this.$drawer.length) {
            return false;
        }
        this.drawerIsOpen = false;
        this.init();
    }
    Drawer.prototype.init = function () {
        $(this.config.open).on("click", $.proxy(this.open, this));
        this.$drawer.on("click", this.config.close, $.proxy(this.close, this));
    };
    Drawer.prototype.open = function (evt) {
        var externalCall = false;
        if (evt) {
            evt.preventDefault();
        } else {
            externalCall = true;
        }
        if (evt && evt.stopPropagation) {
            evt.stopPropagation();
            this.$activeSource = $(evt.currentTarget);
        }
        if (this.drawerIsOpen && !externalCall) {
            return this.close();
        }
        this.$drawer.prepareTransition();
        this.nodes.$parent.addClass(this.config.openClass + " " + this.config.dirOpenClass);
        this.drawerIsOpen = true;
        slate.a11y.trapFocus({ $container: this.$drawer, namespace: "drawer_focus" });
        if (this.config.onDrawerOpen && typeof this.config.onDrawerOpen === "function") {
            if (!externalCall) {
                this.config.onDrawerOpen();
            }
        }
        if (this.$activeSource && this.$activeSource.attr("aria-expanded")) {
            this.$activeSource.attr("aria-expanded", "true");
        }
        this.bindEvents();
        return this;
    };
    Drawer.prototype.close = function () {
        if (!this.drawerIsOpen) {
            return;
        }
        $(document.activeElement).trigger("blur");
        this.$drawer.prepareTransition();
        this.nodes.$parent.removeClass(this.config.dirOpenClass + " " + this.config.openClass);
        this.drawerIsOpen = false;
        slate.a11y.removeTrapFocus({ $container: this.$drawer, namespace: "drawer_focus" });
        this.unbindEvents();
    };
    Drawer.prototype.bindEvents = function () {
        this.nodes.$parent.on(
            "keyup.drawer",
            $.proxy(function (evt) {
                if (evt.keyCode === 27) {
                    this.close();
                    return false;
                } else {
                    return true;
                }
            }, this)
        );
        this.nodes.$page.on("touchmove.drawer", function () {
            return false;
        });
        this.nodes.$page.on(
            "click.drawer",
            $.proxy(function () {
                this.close();
                return false;
            }, this)
        );
    };
    Drawer.prototype.unbindEvents = function () {
        this.nodes.$page.off(".drawer");
        this.nodes.$parent.off(".drawer");
    };
    return Drawer;
})();
window.theme = window.theme || {};
theme.Filters = (function () {
    var constants = { SORT_BY: "sort_by" };
    var selectors = { filterSelection: ".filters-toolbar__input--filter", sortSelection: ".filters-toolbar__input--sort", defaultSort: ".collection-header__default-sort" };
    function Filters(container) {
        var $container = (this.$container = $(container));
        this.$filterSelect = $(selectors.filterSelection, $container);
        this.$sortSelect = $(selectors.sortSelection, $container);
        this.$selects = $(selectors.filterSelection, $container).add($(selectors.sortSelection, $container));
        this.defaultSort = this._getDefaultSortValue();
        this.$selects.removeClass("hidden");
        this.$filterSelect.on("change", this._onFilterChange.bind(this));
        this.$sortSelect.on("change", this._onSortChange.bind(this));
    }
    Filters.prototype = _.assignIn({}, Filters.prototype, {
        _onSortChange: function _onSortChange(evt) {
            var sort = this._sortValue();
            if (sort.length) {
                window.location.search = sort;
            } else {
                window.location.href = window.location.href.replace(window.location.search, "");
            }
        },
        _onFilterChange: function _onFilterChange(evt) {
            window.location.href = this.$filterSelect.val() + window.location.search;
        },
        _getSortValue: function _getSortValue() {
            return this.$sortSelect.val() || this.defaultSort;
        },
        _getDefaultSortValue: function _getDefaultSortValue() {
            return $(selectors.defaultSort, this.$container).val();
        },
        _sortValue: function _sortValue() {
            var sort = this._getSortValue();
            var query = "";
            if (sort !== this.defaultSort) {
                query = constants.SORT_BY + "=" + sort;
            }
            return query;
        },
        onUnload: function onUnload() {
            this.$filterSelect.off("change", this._onFilterChange);
            this.$sortSelect.off("change", this._onSortChange);
        },
    });
    return Filters;
})();
slate.rte = {
    wrapTable: function wrapTable() {
        $(".rte table").wrap('<div class="rte__table-wrapper"></div>');
    },
    iframeReset: function iframeReset() {
        var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
        var $iframeReset = $iframeVideo.add(".rte iframe#admin_bar_iframe");
        $iframeVideo.each(function () {
            $(this).wrap('<div class="video-wrapper"></div>');
        });
        $iframeReset.each(function () {
            this.src = this.src;
        });
    },
};
window.slate = window.slate || {};
slate.a11y = {
    pageLinkFocus: function pageLinkFocus($element) {
        var focusClass = "js-focus-hidden";
        $element.first().attr("tabIndex", "-1").focus().addClass(focusClass).one("blur", callback);
        function callback() {
            $element.first().removeClass(focusClass).removeAttr("tabindex");
        }
    },
    focusHash: function focusHash() {
        var hash = window.location.hash;
        if (hash && document.getElementById(hash.slice(1))) {
            this.pageLinkFocus($(hash));
        }
    },
    bindInPageLinks: function bindInPageLinks() {
        $("a[href*=#]").on(
            "click",
            function (evt) {
                this.pageLinkFocus($(evt.currentTarget.hash));
            }.bind(this)
        );
    },
    trapFocus: function trapFocus(options) {
        var eventName = options.namespace ? "focusin." + options.namespace : "focusin";
        if (!options.$elementToFocus) {
            options.$elementToFocus = options.$container;
        }
        options.$container.attr("tabindex", "-1");
        options.$elementToFocus.focus();
        $(document).off("focusin");
        $(document).on(eventName, function (evt) {
            if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
                options.$container.focus();
            }
        });
    },
    removeTrapFocus: function removeTrapFocus(options) {
        var eventName = options.namespace ? "focusin." + options.namespace : "focusin";
        if (options.$container && options.$container.length) {
            options.$container.removeAttr("tabindex");
        }
        $(document).off(eventName);
    },
};
theme.Images = (function () {
    function preload(images, size) {
        if (typeof images === "string") {
            images = [images];
        }
        for (var i = 0; i < images.length; i++) {
            var image = images[i];
            this.loadImage(this.getSizedImageUrl(image, size));
        }
    }
    function loadImage(path) {
        new Image().src = path;
    }
    function switchImage(image, element, callback) {}
    function getSizedImageUrl(src, size) {
        if (size == null) {
            return src;
        }
        if (size === "master") {
            return this.removeProtocol(src);
        }
        var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (match != null) {
            var prefix = src.split(match[0]);
            var suffix = match[0];
            return this.removeProtocol(prefix[0] + "_" + size + suffix);
        }
        return null;
    }
    function removeProtocol(path) {
        return path.replace(/http(s)?:/, "");
    }
    return { preload: preload, loadImage: loadImage, switchImage: switchImage, getSizedImageUrl: getSizedImageUrl, removeProtocol: removeProtocol };
})();
theme.Images = (function () {
    function preload(images, size) {
        if (typeof images === "string") {
            images = [images];
        }
        for (var i = 0; i < images.length; i++) {
            var image = images[i];
            this.loadImage(this.getSizedImageUrl(image, size));
        }
    }
    function loadImage(path) {
        new Image().src = path;
    }
    function switchImage(image, element, callback) {
        var size = this.imageSize(element.src);
        var imageUrl = this.getSizedImageUrl(image.src, size);
        if (callback) {
            callback(imageUrl, image, element);
        } else {
            element.src = imageUrl;
        }
    }
    function imageSize(src) {
        var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/);
        if (match !== null) {
            if (match[2] !== undefined) {
                return match[1] + match[2];
            } else {
                return match[1];
            }
        } else {
            return null;
        }
    }
    function getSizedImageUrl(src, size) {
        if (size === null) {
            return src;
        }
        if (size === "master") {
            return this.removeProtocol(src);
        }
        var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (match !== null) {
            var prefix = src.split(match[0]);
            var suffix = match[0];
            return this.removeProtocol(prefix[0] + "_" + size + suffix);
        }
        return null;
    }
    function removeProtocol(path) {
        return path.replace(/http(s)?:/, "");
    }
    return { preload: preload, loadImage: loadImage, switchImage: switchImage, imageSize: imageSize, getSizedImageUrl: getSizedImageUrl, removeProtocol: removeProtocol };
})();
theme.Currency = (function () {
    var moneyFormat = currencyFormat.shopifyMoneyFormat;
    function formatMoney(cents, format) {
        if (typeof cents === "string") {
            cents = cents.replace(".", "");
        }
        var value = "";
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format || moneyFormat;
        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = precision || 2;
            thousands = thousands || ",";
            decimal = decimal || ".";
            if (isNaN(number) || number == null) {
                return 0;
            }
            number = (number / 100).toFixed(precision);
            var parts = number.split(".");
            var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
            var centsAmount = parts[1] ? decimal + parts[1] : "";
            return dollarsAmount + centsAmount;
        }
        switch (formatString.match(placeholderRegex)[1]) {
            case "amount":
                value = formatWithDelimiters(cents, 2);
                break;
            case "amount_no_decimals":
                value = formatWithDelimiters(cents, 0);
                break;
            case "amount_with_comma_separator":
                value = formatWithDelimiters(cents, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                value = formatWithDelimiters(cents, 0, ".", ",");
                break;
            case "amount_no_decimals_with_space_separator":
                value = formatWithDelimiters(cents, 0, " ");
                break;
        }
        return formatString.replace(placeholderRegex, value);
    }
    return { formatMoney: formatMoney };
})();
window.theme = window.theme || {};
theme.Maps = (function () {
    var config = { zoom: 14 };
    var apiStatus = null;
    var mapsToLoad = [];
    var key = theme.mapKey ? theme.mapKey : "";
    function Map(container) {
        this.$container = $(container);
        if (apiStatus === "loaded") {
            this.createMap();
        } else {
            mapsToLoad.push(this);
            if (apiStatus !== "loading") {
                apiStatus = "loading";
                if (typeof window.google === "undefined") {
                    $.getScript("https://maps.googleapis.com/maps/api/js?key=" + key).then(function () {
                        apiStatus = "loaded";
                        initAllMaps();
                    });
                }
            }
        }
    }
    function initAllMaps() {
        $.each(mapsToLoad, function (index, instance) {
            instance.createMap();
        });
    }
    function geolocate($map) {
        var deferred = $.Deferred();
        var geocoder = new google.maps.Geocoder();
        var address = $map.data("address-setting");
        geocoder.geocode({ address: address }, function (results, status) {
            if (status !== google.maps.GeocoderStatus.OK) {
                deferred.reject(status);
            }
            deferred.resolve(results);
        });
        return deferred;
    }
    Map.prototype = _.assignIn({}, Map.prototype, {
        createMap: function createMap() {
            var $map = this.$container.find(".map-section__container");
            return geolocate($map)
                .then(
                    function (results) {
                        var mapOptions = { zoom: config.zoom, center: results[0].geometry.location, disableDefaultUI: true };
                        var map = (this.map = new google.maps.Map($map[0], mapOptions));
                        var center = (this.center = map.getCenter());
                        var marker = new google.maps.Marker({ map: map, position: map.getCenter() });
                        google.maps.event.addDomListener(
                            window,
                            "resize",
                            $.debounce(250, function () {
                                google.maps.event.trigger(map, "resize");
                                map.setCenter(center);
                            })
                        );
                    }.bind(this)
                )
                .fail(function () {
                    var errorMessage;
                    switch (status) {
                        case "ZERO_RESULTS":
                            errorMessage = theme.strings.addressNoResults;
                            break;
                        case "OVER_QUERY_LIMIT":
                            errorMessage = theme.strings.addressQueryLimit;
                            break;
                        default:
                            errorMessage = theme.strings.addressError;
                            break;
                    }
                    $map.parent()
                        .addClass("page-width map-section--load-error")
                        .html('<div class="errors text-center">' + errorMessage + "</div>");
                });
        },
        onUnload: function onUnload() {
            google.maps.event.clearListeners(this.map, "resize");
        },
    });
    return Map;
})();
function gm_authFailure() {
    $(".map-section").addClass("map-section--load-error");
    $(".map-section__container").remove();
    $(".map-section__link").remove();
    $(".map-section__overlay").after('<div class="errors text-center">' + theme.strings.authError + "</div>");
}
window.theme = window.theme || {};
theme.MobileNav = (function () {
    var classes = {
        mobileNavOpenIcon: "mobile-nav--open",
        mobileNavLockHead: "mobile-nav--lock-header",
        mobileNavCloseIcon: "mobile-nav--close",
        navLinkWrapper: "mobile-nav__item",
        navLink: "mobile-nav__link",
        subNavLink: "mobile-nav__sublist-link",
        return: "mobile-nav__return-btn",
        subNavActive: "is-active",
        subNavClosing: "is-closing",
        navOpen: "js-menu--is-open",
        subNavShowing: "sub-nav--is-open",
        thirdNavShowing: "third-nav--is-open",
        subNavToggleBtn: "js-toggle-submenu",
    };
    var cache = {};
    var isTransitioning;
    var $activeSubNav;
    var $activeTrigger;
    var menuLevel = 1;
    var mediaQuerySmall = "screen and (max-width: 749px)";
    function init() {
        cacheSelectors();
        cache.$mobileNavToggle.on("click", toggleMobileNav);
        cache.$subNavToggleBtn.on("click.subNav", toggleSubNav);
        enquire.register(mediaQuerySmall, {
            unmatch: function unmatch() {
                closeMobileNav();
            },
        });
    }
    function toggleMobileNav() {
        if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
            closeMobileNav();
        } else {
            if ($("body").hasClass("js-drawer-open-top")) {
                $(".js-drawer-open-top").trigger("click");
            }
            openMobileNav();
        }
    }
    function cacheSelectors() {
        cache = {
            $body: $("body"),
            $pageContainer: $("#PageContainer"),
            $siteHeader: $(".site-header"),
            $siteHeaderWrapper: $(".site-header--wrapper"),
            $mobileNavToggle: $(".js-mobile-nav-toggle"),
            $mobileNavContainer: $(".mobile-nav-wrapper"),
            $mobileNav: $("#MobileNav"),
            $sectionHeader: $("#shopify-section-header"),
            $subNavToggleBtn: $("." + classes.subNavToggleBtn),
        };
    }
    function openMobileNav() {
        cache.$mobileNavContainer.prepareTransition().addClass(classes.navOpen);
        slate.a11y.trapFocus({ $container: cache.$sectionHeader, $elementToFocus: cache.$mobileNav.find("." + classes.navLinkWrapper + ":first").find("." + classes.navLink), namespace: "navFocus" });
        cache.$body.css({ overflow: "hidden" });
        cache.$mobileNavToggle.addClass(classes.mobileNavCloseIcon).removeClass(classes.mobileNavOpenIcon);
        $(window).on("keyup.mobileNav", function (evt) {
            if (evt.which === 27) {
                closeMobileNav();
            }
        });
    }
    function closeMobileNav() {
        cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);
        cache.$siteHeaderWrapper.removeClass(classes.mobileNavLockHead);
        cache.$pageContainer.removeAttr("style");
        cache.$mobileNavContainer.one("TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle", function () {
            slate.a11y.removeTrapFocus({ $container: cache.$mobileNav, namespace: "navFocus" });
        });
        cache.$body.css({ overflow: "initial", position: "initial" });
        cache.$mobileNavToggle.addClass(classes.mobileNavOpenIcon).removeClass(classes.mobileNavCloseIcon);
        $(window).off("keyup.mobileNav");
    }
    function toggleSubNav(evt) {
        if (isTransitioning) {
            return;
        }
        var $toggleBtn = $(evt.currentTarget);
        var isReturn = $toggleBtn.hasClass(classes.return);
        isTransitioning = true;
        if (isReturn) {
            $("." + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]').removeClass(classes.subNavActive);
            if ($activeTrigger && $activeTrigger.length) {
                $activeTrigger.removeClass(classes.subNavActive);
            }
        } else {
            $toggleBtn.addClass(classes.subNavActive);
        }
        $activeTrigger = $toggleBtn;
        goToSubnav($toggleBtn.data("target"));
    }
    function goToSubnav(target) {
        var $targetMenu = target ? $('.mobile-nav__dropdown[data-parent="' + target + '"]') : cache.$mobileNav;
        menuLevel = $targetMenu.data("level") ? $targetMenu.data("level") : 1;
        if ($activeSubNav && $activeSubNav.length) {
            $activeSubNav.addClass(classes.subNavClosing);
        }
        $activeSubNav = $targetMenu;
        var $elementToFocus = target ? $targetMenu.find("." + classes.subNavLink + ":first") : $activeTrigger;
        var translateMenuHeight = $targetMenu.outerHeight();
        var openNavClass = menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;
        cache.$mobileNavContainer.css("height", translateMenuHeight).removeClass(classes.thirdNavShowing).addClass(openNavClass);
        if (!target) {
            cache.$mobileNavContainer.removeClass(classes.thirdNavShowing).removeClass(classes.subNavShowing);
        }
        cache.$mobileNavContainer.one("TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle", function () {
            slate.a11y.trapFocus({ $container: $targetMenu, $elementToFocus: $elementToFocus, namespace: "subNavFocus" });
            cache.$mobileNavContainer.off(".subnavToggle");
            isTransitioning = false;
        });
        $activeSubNav.removeClass(classes.subNavClosing);
    }
    return { init: init, closeMobileNav: closeMobileNav };
})(jQuery);
window.theme = window.theme || {};
theme.NewsletterPopup = (function () {
    var init = function init() {
        _initModal();
        _cacheDom();
        _bindEvents();
    };
    var selectors = {
        body: "body",
        modal: "#newsletter",
        modalInit: ".modaal--cornered",
        modalOverlay: ".modaal-overlay",
        modalWrapper: ".modaal-wrapper",
        modalContent: ".modaal-content",
        modalClose: ".modaal-close",
        form: "#mc-embedded-subscribe",
    };
    var cache = {};
    var _cacheDom = function _cacheDom() {
        cache = {
            $window: $(window),
            $body: $(selectors.body),
            $modal: $(selectors.modal),
            $modalOverlay: $(selectors.modalOverlay),
            $form: $(selectors.form),
            $modalWrapper: $(selectors.modalWrapper),
            $modalContent: $(selectors.modalContent),
        };
    };
    var _bindEvents = function _bindEvents() {
        cache.$form.on("submit", _submitForm.bind(this));
    };
    var _modalSettings = {
        start_open: true,
        background: theme.settings.modaalBg,
        custom_class: "modaal--cornered",
        overlay_opacity: 0,
        after_open: function after_open(modal) {
            cache.$body.removeClass("modaal-noscroll");
            cache.$modalOverlay.hide();
            var modal = $(selectors.modal).attr("data-modaal-scope");
            $("#" + modal)
                .find(cache.$modalContent)
                .attr("tabindex", "-1");
        },
        after_close: function after_close() {
            if (Cookies.get("newsletter") != "signedup") {
                Cookies.set("newsletter", "closed", { expires: 60, path: "/" });
            }
        },
    };
    var _initModal = function _initModal() {
        if (theme.redirectModal != true) {
            if (Cookies.get("newsletter") == undefined || (Cookies.get("newsletter") != "closed" && Cookies.get("newsletter") != "signedup")) {
                $(selectors.modal).modaal(_modalSettings);
            }
            setTimeout(function () {
                $(selectors.modalInit).addClass("active");
                $(selectors.modalClose).on("click", function () {
                    $(selectors.modalInit).removeClass("active");
                });
            }, window.newsletterTimer);
        }
    };
    var _submitForm = function _submitForm(event) {
        event.preventDefault();
        var form = $(event.target);
        var error_msg = theme.strings.newsletterError;
        $.ajax({
            type: form.attr("method"),
            url: form.attr("action"),
            data: form.serialize(),
            cache: false,
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            error: function error(err) {
                console.log(theme.strings.newsletterConsoleError);
            },
            success: function success(data) {
                if (data.result != "success") {
                    if (data.msg != "") {
                        error_msg = data.msg;
                    }
                    $(".newsletter__response").html('<span class="error">' + error_msg + "</span>");
                } else {
                    Cookies.set("newsletter", "signedup", { expires: 365, path: "/" });
                    $(".newsletter__response").html("<span>" + theme.strings.newsletterSuccess + "</span>");
                    form.hide();
                    setTimeout(function () {
                        $("#newsletter").modaal("close");
                    }, 1500);
                }
            },
        });
    };
    return { init: init };
})();
theme.NewsletterPopup.init();
window.theme = window.theme || {};
theme.Quantity = (function () {
    var selectors = { siteHeader: ".site-header--wrapper", quantitySelector: ".item-quantity__increment, .cart-ajax__remove", quantityInput: ".item-quantity__input", quantityInputWrapper: ".item-quantity--input-wrapper" };
    function init(container) {
        if (!$(selectors.siteHeader).length) {
            return;
        }
        $(document).on("click", selectors.quantitySelector, _updateQuantityEvt.bind(this));
        $(document).on("quantityChanged", _updateQuantity.bind(this));
    }
    function _updateQuantityEvt(evt) {
        var evtTarget = evt.target;
        $(document).trigger({ type: "quantityChanged", target: evtTarget });
        evt.preventDefault();
    }
    function _updateQuantity(evt) {
        var target = evt.target;
        var targetInput = $(target).parents(selectors.quantityInputWrapper).find(selectors.quantityInput);
        var inputValue = parseInt($(targetInput).prop("value"));
        var quantity = $(target).hasClass("item-quantity__increment--plus") ? inputValue + 1 : (inputValue < 1 ? 1 : inputValue) - 1;
        $(targetInput).val(quantity);
        if ($(target).parents(".cart-ajax__row").length > 0) {
            $(document).trigger({ type: "updateCart", inputType: target, variant: $(target).parents(".cart-ajax__row").data("variant"), quantity: inputValue });
        } else if ($(target).parents(".cart__row").length > 0) {
            $(document).trigger({ type: "updateCart", inputType: target, variant: $(target).parents(".cart__row").data("variant"), quantity: inputValue });
        }
    }
    return { init: init };
})();
theme.QuickAdd = (function () {
    var init = function init() {
        bindEvents();
    };
    var selectors = { quickAddButton: "[open-quick-add]", closeQuickAddButton: "[close-quick-add]", quickAddSubmitButton: "[quick-add-submit]", productForm: ".product-form", productFormQuickadd: ".product-form--quickadd" };
    var bindEvents = function bindEvents() {
        $(selectors.quickAddButton).on("click", openQuickAdd.bind(this));
        $(selectors.closeQuickAddButton).on("click", closeQuickAdd.bind(this));
        $(selectors.quickAddSubmitButton).on("click", quickAddSubmit.bind(this));
    };
    var openQuickAdd = function openQuickAdd(event) {
        var element = event.currentTarget;
        var quickAdd = $(element).data("pos-id");
        var productForm = $(selectors.productFormQuickadd + "[data-pos-id=" + quickAdd + "]");
        productForm.addClass("product-form--quickadd--open");
    };
    var closeQuickAdd = function closeQuickAdd(event) {
        var element = event.currentTarget;
        var quickAdd = $(element).data("pos-id");
        var productForm = $(selectors.productFormQuickadd + "[data-pos-id=" + quickAdd + "]");
        productForm.removeClass("product-form--quickadd--open");
    };
    var quickAddSubmit = function quickAddSubmit(event) {
        event.preventDefault();
        var element = event.currentTarget,
            quickAdd = $(element).data("product-id"),
            productForm = $(selectors.productForm + "[data-section-id=" + quickAdd + "]"),
            formData = $(productForm).serialize(),
            $this = $(event.target);
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: formData,
            dataType: "json",
            success: function success(cartData) {
                $this.trigger({ type: "AjaxAddToCart", response: cartData });
                $this.trigger({ type: "AjaxCartRequest", response: cartData });
            },
            error: function error(request, status) {
                $this.trigger({ type: "AjaxAddToCart", response: request });
            },
        });
    };
    return { init: init };
})();
window.theme = window.theme || {};
theme.quickview = (function () {
  if( $('.quickview').length ) {
    $(".quickview").modaal({
        type: "ajax",
        background: theme.settings.modaalBg,
        loading_content: '<div class="loader"></div>',
        ajax_success: function ajax_success() {
            $(document).trigger({ type: "quickViewOpen" });
        },
    });
  }
})();
window.theme = window.theme || {};
theme.Quotes = (function () {
    var config = { mediaQuerySmall: "screen and (max-width: 749px)", mediaQueryMediumUp: "screen and (min-width: 750px)", slideCount: 0 };
    var defaults = { accessibility: true, arrows: false, dots: true, autoplay: false, touchThreshold: 20, slidesToShow: 3, slidesToScroll: 3 };
    function Quotes(container) {
        var $container = (this.$container = $(container));
        var sectionId = $container.attr("data-section-id");
        var wrapper = (this.wrapper = ".quotes-wrapper");
        var slider = (this.slider = "#Quotes-" + sectionId);
        var $slider = $(slider, wrapper);
        var sliderActive = false;
        var mobileOptions = $.extend({}, defaults, { slidesToShow: 1, slidesToScroll: 1, adaptiveHeight: true });
        config.slideCount = $slider.data("count");
        if (config.slideCount < defaults.slidesToShow) {
            defaults.slidesToShow = config.slideCount;
            defaults.slidesToScroll = config.slideCount;
        }
        $slider.on("init", this.a11y.bind(this));
        enquire.register(config.mediaQuerySmall, {
            match: function match() {
                initSlider($slider, mobileOptions);
            },
        });
        enquire.register(config.mediaQueryMediumUp, {
            match: function match() {
                initSlider($slider, defaults);
            },
        });
        function initSlider(sliderObj, args) {
            if (sliderActive) {
                sliderObj.slick("unslick");
                sliderActive = false;
            }
            sliderObj.slick(args);
            sliderActive = true;
        }
    }
    Quotes.prototype = _.assignIn({}, Quotes.prototype, {
        onUnload: function onUnload() {
            enquire.unregister(config.mediaQuerySmall);
            enquire.unregister(config.mediaQueryMediumUp);
            $(this.slider, this.wrapper).slick("unslick");
        },
        onBlockSelect: function onBlockSelect(evt) {
            var $slide = $(".quotes-slide--" + evt.detail.blockId + ":not(.slick-cloned)");
            var slideIndex = $slide.data("slick-index");
            $(this.slider, this.wrapper).slick("slickGoTo", slideIndex);
        },
        a11y: function a11y(event, obj) {
            var $list = obj.$list;
            var $wrapper = $(this.wrapper, this.$container);
            $list.removeAttr("aria-live");
            $wrapper.on("focusin", function (evt) {
                if ($wrapper.has(evt.target).length) {
                    $list.attr("aria-live", "polite");
                }
            });
            $wrapper.on("focusout", function (evt) {
                if ($wrapper.has(evt.target).length) {
                    $list.removeAttr("aria-live");
                }
            });
        },
    });
    return Quotes;
})();
window.theme = window.theme || {};
theme.Search = (function () {
    var selectors = {
        search: ".search",
        searchSubmit: ".search__submit",
        searchInput: ".search__input",
        siteHeader: ".site-header--wrapper",
        siteHeaderSearchToggle: ".site-header__search-toggle",
        siteHeaderSearch: ".site-header__search",
        searchDrawer: ".search-bar",
        searchDrawerInput: ".search-bar__input",
        searchHeader: ".search-header",
        searchHeaderInput: ".search-header__input",
        searchHeaderSubmit: ".search-header__submit",
        mobileNavWrapper: ".mobile-nav-wrapper",
    };
    var classes = { focus: "search--focus", mobileNavIsOpen: "js-menu--is-open" };
    var siteHeaderHeight = $(selectors.siteHeader).height();
    function init() {
        if (!$(selectors.siteHeader).length) {
            return;
        }
        _bindEvents();
        initDrawer();
        searchSubmit();
    }
    function _bindEvents() {
        $(window).on(
            "resize",
            $.debounce(250, function () {
                siteHeaderHeight = $(selectors.siteHeader).height();
            })
        );
        $(selectors.searchHeaderInput)
            .add(selectors.searchHeaderSubmit)
            .on("focus blur", function () {
                $(selectors.searchHeader).toggleClass(classes.focus);
            });
        $(selectors.siteHeaderSearchToggle).on("click", function () {
            toggleSearch(siteHeaderHeight);
        });
    }
    function toggleSearch(siteHeaderHeight) {
        var searchHeight = 84;
        var searchOffset = siteHeaderHeight;
        window.scrollTo(0, 0);
        $(selectors.searchDrawer).css({ height: searchHeight + "px", top: searchOffset + "px" });
        theme.MobileNav.closeMobileNav();
    }
    function initDrawer() {
        $("#PageContainer").addClass("drawer-page-content");
        $(".js-drawer-open-top").attr("aria-controls", "SearchDrawer").attr("aria-expanded", "false");
        theme.SearchDrawer = new theme.Drawers("SearchDrawer", "top", { onDrawerOpen: searchDrawerFocus });
    }
    function searchDrawerFocus() {
        searchFocus($(selectors.searchDrawerInput));
        if ($(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
            theme.MobileNav.closeMobileNav();
        }
    }
    function searchFocus($el) {
        $el.focus();
        $el[0].setSelectionRange(0, $el[0].value.length);
    }
    function searchSubmit() {
        $(selectors.searchSubmit).on("click", function (evt) {
            var $el = $(evt.target);
            var $input = $el.parents(selectors.search).find(selectors.searchInput);
            if ($input.val().length === 0) {
                evt.preventDefault();
                searchFocus($input);
            }
        });
    }
    return { init: init };
})();
(function () {
    var selectors = { backButton: ".return-link" };
    var $backButton = $(selectors.backButton);
    if (!document.referrer || !$backButton.length || !window.history.length) {
        return;
    }
    $backButton.one("click", function (evt) {
        evt.preventDefault();
        var referrerDomain = urlDomain(document.referrer);
        var shopDomain = urlDomain(window.location.href);
        if (shopDomain === referrerDomain) {
            history.back();
        }
        return false;
    });
    function urlDomain(url) {
        var anchor = document.createElement("a");
        anchor.ref = url;
        return anchor.hostname;
    }
})();
window.theme = window.theme || {};
theme.slickInit = (function () {
    function slickInit() {
        $(".slick-init").slick({
            dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 3,
            responsive: [
                { breakpoint: 990, settings: "unslick" },
                { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
                { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
            ],
        });
    }
    return { init: slickInit };
})();
var slickIndex = [];
theme.Slideshow = (function () {
    var classes = {
        wrapper: "slideshow-wrapper",
        slideshow: "slideshow",
        currentSlide: "slick-current",
        video: "slideshow__video",
        videoBackground: "slideshow__video--background",
        closeVideoBtn: "slideshow__video-control--close",
        pauseButton: "slideshow__pause",
        isPaused: "is-paused",
        textContent: ".slideshow__text-content",
    };
    function slideshow(el) {
        this.$slideshow = $(el);
        this.$wrapper = this.$slideshow.closest("." + classes.wrapper);
        this.$pause = this.$wrapper.find("." + classes.pauseButton);
        this.settings = {
            accessibility: true,
            arrows: true,
            dots: false,
            fade: true,
            draggable: true,
            touchThreshold: 20,
            autoplay: this.$slideshow.data("autoplay"),
            autoplaySpeed: this.$slideshow.data("speed"),
            prevArrow: $(".slick-prev"),
            nextArrow: $(".slick-next"),
            responsive: [{ breakpoint: 843, settings: { dots: true } }],
        };
        this.$slideshow.on("beforeChange", beforeChange.bind(this));
        this.$slideshow.on("init", slideshowA11y.bind(this));
        $(this.$slideshow).slick(this.settings);
        this.$pause.on("click", this.togglePause.bind(this));
    }
    function slideshowA11y(event, obj) {
        var $slider = obj.$slider;
        var $list = obj.$list;
        var $wrapper = this.$wrapper;
        var autoplay = this.settings.autoplay;
        $list.removeAttr("aria-live");
        $wrapper.on("focusin", function (evt) {
            if (!$wrapper.has(evt.target).length) {
                return;
            }
            $list.attr("aria-live", "polite");
            if (autoplay) {
                $slider.slick("slickPause");
            }
        });
        $wrapper.on("focusout", function (evt) {
            if (!$wrapper.has(evt.target).length) {
                return;
            }
            $list.removeAttr("aria-live");
            if (autoplay) {
                if ($(evt.target).hasClass(classes.closeVideoBtn)) {
                    return;
                }
                $slider.slick("slickPlay");
            }
        });
        if (obj.$dots) {
            obj.$dots.on("keydown", function (evt) {
                if (evt.which === 37) {
                    $slider.slick("slickPrev");
                }
                if (evt.which === 39) {
                    $slider.slick("slickNext");
                }
                if (evt.which === 37 || evt.which === 39) {
                    obj.$dots.find(".slick-active button").focus();
                }
            });
        }
    }
    function beforeChange(event, slick, currentSlide, nextSlide) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find("." + classes.currentSlide);
        var $nextSlide = $slider.find('.slideshow__slide[data-slick-index="' + nextSlide + '"]');
        if (isVideoInSlide($currentSlide)) {
            var $currentVideo = $currentSlide.find("." + classes.video);
            var currentVideoId = $currentVideo.attr("id");
            theme.SlideshowVideo.pauseVideo(currentVideoId);
            $currentVideo.attr("tabindex", "-1");
        }
        if (isVideoInSlide($nextSlide)) {
            var $video = $nextSlide.find("." + classes.video);
            var videoId = $video.attr("id");
            var isBackground = $video.hasClass(classes.videoBackground);
            if (isBackground) {
                theme.SlideshowVideo.playVideo(videoId);
            } else {
                $video.attr("tabindex", "0");
            }
        }
    }
    function isVideoInSlide($slide) {
        return $slide.find("." + classes.video).length;
    }
    slideshow.prototype.togglePause = function () {
        var slideshowSelector = getSlideshowId(this.$pause);
        if (this.$pause.hasClass(classes.isPaused)) {
            this.$pause.removeClass(classes.isPaused);
            $(slideshowSelector).slick("slickPlay");
        } else {
            this.$pause.addClass(classes.isPaused);
            $(slideshowSelector).slick("slickPause");
        }
    };
    function getSlideshowId($el) {
        return "#Slideshow-" + $el.data("id");
    }
    return slideshow;
})();
function onYouTubeIframeAPIReady() {
    theme.SlideshowVideo.loadVideos();
}
theme.SlideshowVideo = (function () {
    var autoplayCheckComplete = false;
    var autoplayAvailable = false;
    var playOnClickChecked = false;
    var playOnClick = false;
    var youtubeLoaded = false;
    var videos = {};
    var videoPlayers = [];
    var videoOptions = {
        ratio: 16 / 9,
        playerVars: { iv_load_policy: 3, modestbranding: 1, autoplay: 0, controls: 0, showinfo: 0, wmode: "opaque", branding: 0, autohide: 0, rel: 0 },
        events: { onReady: onPlayerReady, onStateChange: onPlayerChange },
    };
    var classes = {
        playing: "video-is-playing",
        paused: "video-is-paused",
        loading: "video-is-loading",
        loaded: "video-is-loaded",
        slideshowWrapper: "slideshow-wrapper",
        slide: "slideshow__slide",
        slideBackgroundVideo: "slideshow__slide--background-video",
        slideDots: "slick-dots",
        videoChrome: "slideshow__video--chrome",
        videoBackground: "slideshow__video--background",
        playVideoBtn: "slideshow__video-control--play",
        closeVideoBtn: "slideshow__video-control--close",
        currentSlide: "slick-current",
        slickClone: "slick-cloned",
        supportsAutoplay: "autoplay",
        supportsNoAutoplay: "no-autoplay",
    };
    function init($video) {
        if (!$video.length) {
            return;
        }
        videos[$video.attr("id")] = {
            id: $video.attr("id"),
            videoId: $video.data("id"),
            type: $video.data("type"),
            status: $video.data("type") === "chrome" ? "closed" : "background",
            videoSelector: $video.attr("id"),
            $parentSlide: $video.closest("." + classes.slide),
            $parentSlideshowWrapper: $video.closest("." + classes.slideshowWrapper),
            controls: $video.data("type") === "background" ? 0 : 1,
            slideshow: $video.data("slideshow"),
        };
        if (!youtubeLoaded) {
            var tag = document.createElement("script");
            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName("script")[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
    }
    function customPlayVideo(playerId) {
        if (!playOnClickChecked && !playOnClick) {
            return;
        }
        if (playerId && typeof videoPlayers[playerId].playVideo === "function") {
            privatePlayVideo(playerId);
        }
    }
    function pauseVideo(playerId) {
        if (videoPlayers[playerId] && typeof videoPlayers[playerId].pauseVideo === "function") {
            videoPlayers[playerId].pauseVideo();
        }
    }
    function loadVideos() {
        for (var key in videos) {
            if (videos.hasOwnProperty(key)) {
                var args = $.extend({}, videoOptions, videos[key]);
                args.playerVars.controls = args.controls;
                videoPlayers[key] = new YT.Player(key, args);
            }
        }
        initEvents();
        youtubeLoaded = true;
    }
    function loadVideo(key) {
        if (!youtubeLoaded) {
            return;
        }
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
        initEvents();
    }
    function privatePlayVideo(id, clicked) {
        var videoData = videos[id];
        var player = videoPlayers[id];
        var $slide = videos[id].$parentSlide;
        if (playOnClick) {
            setAsPlaying(videoData);
        } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
            $slide.removeClass(classes.loading);
            setAsPlaying(videoData);
            player.playVideo();
            return;
        }
        if (!autoplayCheckComplete) {
            autoplayCheckFunction(player, $slide);
        }
    }
    function setAutoplaySupport(supported) {
        var supportClass = supported ? classes.supportsAutoplay : classes.supportsNoAutoplay;
        $(document.documentElement).addClass(supportClass);
        if (!supported) {
            playOnClick = true;
        }
        autoplayCheckComplete = true;
    }
    function autoplayCheckFunction(player, $slide) {
        player.playVideo();
        autoplayTest(player)
            .then(function () {
                setAutoplaySupport(true);
            })
            .fail(function () {
                setAutoplaySupport(false);
                player.stopVideo();
            })
            .always(function () {
                autoplayCheckComplete = true;
                $slide.removeClass(classes.loading);
            });
    }
    function autoplayTest(player) {
        var deferred = $.Deferred();
        var wait;
        var timeout;
        wait = setInterval(function () {
            if (player.getCurrentTime() <= 0) {
                return;
            }
            autoplayAvailable = true;
            clearInterval(wait);
            clearTimeout(timeout);
            deferred.resolve();
        }, 500);
        timeout = setTimeout(function () {
            clearInterval(wait);
            deferred.reject();
        }, 4000);
        return deferred;
    }
    function playOnClickCheck() {
        if (playOnClickChecked) {
            return;
        }
        if ($(window).width() < 750) {
            playOnClick = true;
        } else if (window.mobileCheck()) {
            playOnClick = true;
        }
        if (playOnClick) {
            setAutoplaySupport(false);
        }
        playOnClickChecked = true;
    }
    function onPlayerReady(evt) {
        evt.target.setPlaybackQuality("hd1080");
        var videoData = getVideoOptions(evt);
        playOnClickCheck();
        $("#" + videoData.id).attr("tabindex", "-1");
        sizeBackgroundVideos();
        switch (videoData.type) {
            case "background-chrome":
            case "background":
                evt.target.mute();
                if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
                    privatePlayVideo(videoData.id);
                }
                break;
        }
        videoData.$parentSlide.addClass(classes.loaded);
    }
    function onPlayerChange(evt) {
        var videoData = getVideoOptions(evt);
        switch (evt.data) {
            case 0:
                setAsFinished(videoData);
                break;
            case 1:
                setAsPlaying(videoData);
                break;
            case 2:
                setAsPaused(videoData);
                break;
        }
    }
    function setAsFinished(videoData) {
        switch (videoData.type) {
            case "background":
                videoPlayers[videoData.id].seekTo(0);
                break;
            case "background-chrome":
                videoPlayers[videoData.id].seekTo(0);
                closeVideo(videoData.id);
                break;
            case "chrome":
                closeVideo(videoData.id);
                break;
        }
    }
    function setAsPlaying(videoData) {
        var $slideshow = videoData.$parentSlideshowWrapper;
        var $slide = videoData.$parentSlide;
        $slide.removeClass(classes.loading);
        if (videoData.status === "background") {
            return;
        }
        $("#" + videoData.id).attr("tabindex", "0");
        switch (videoData.type) {
            case "chrome":
            case "background-chrome":
                $slideshow.removeClass(classes.paused).addClass(classes.playing);
                $slide.removeClass(classes.paused).addClass(classes.playing);
                break;
        }
        $slide.find("." + classes.closeVideoBtn).focus();
    }
    function setAsPaused(videoData) {
        var $slideshow = videoData.$parentSlideshowWrapper;
        var $slide = videoData.$parentSlide;
        if (videoData.type === "background-chrome") {
            closeVideo(videoData.id);
            return;
        }
        if (videoData.status !== "closed" && videoData.type !== "background") {
            $slideshow.addClass(classes.paused);
            $slide.addClass(classes.paused);
        }
        if (videoData.type === "chrome" && videoData.status === "closed") {
            $slideshow.removeClass(classes.paused);
            $slide.removeClass(classes.paused);
        }
        $slideshow.removeClass(classes.playing);
        $slide.removeClass(classes.playing);
    }
    function closeVideo(playerId) {
        var videoData = videos[playerId];
        var $slideshow = videoData.$parentSlideshowWrapper;
        var $slide = videoData.$parentSlide;
        var classesToRemove = [classes.pause, classes.playing].join(" ");
        $("#" + videoData.id).attr("tabindex", "-1");
        videoData.status = "closed";
        switch (videoData.type) {
            case "background-chrome":
                videoPlayers[playerId].mute();
                setBackgroundVideo(playerId);
                break;
            case "chrome":
                videoPlayers[playerId].stopVideo();
                setAsPaused(videoData);
                break;
        }
        $slideshow.removeClass(classesToRemove);
        $slide.removeClass(classesToRemove);
    }
    function getVideoOptions(evt) {
        return videos[evt.target.h.id];
    }
    function startVideoOnClick(playerId) {
        var videoData = videos[playerId];
        videoData.$parentSlide.addClass(classes.loading);
        videoData.status = "open";
        switch (videoData.type) {
            case "background-chrome":
                unsetBackgroundVideo(playerId, videoData);
                videoPlayers[playerId].unMute();
                privatePlayVideo(playerId, true);
                break;
            case "chrome":
                privatePlayVideo(playerId, true);
                break;
        }
        $(document).on("keydown.videoPlayer", function (evt) {
            if (evt.keyCode === 27) {
                closeVideo(playerId);
            }
        });
    }
    function sizeBackgroundVideos() {
        $("." + classes.videoBackground).each(function (index, el) {
            sizeBackgroundVideo($(el));
        });
    }
    function sizeBackgroundVideo($player) {
        var $slide = $player.closest("." + classes.slide);
        if ($slide.hasClass(classes.slickClone)) {
            return;
        }
        var slideWidth = $slide.width();
        var playerWidth = $player.width();
        var playerHeight = $player.height();
        if (slideWidth / videoOptions.ratio < playerHeight) {
            playerWidth = Math.ceil(playerHeight * videoOptions.ratio);
            $player
                .width(playerWidth)
                .height(playerHeight)
                .css({ left: (slideWidth - playerWidth) / 2, top: 0 });
        } else {
            playerHeight = Math.ceil(slideWidth / videoOptions.ratio);
            $player
                .width(slideWidth)
                .height(playerHeight)
                .css({ left: 0, top: (playerHeight - playerHeight) / 2 });
        }
        $player.prepareTransition().addClass(classes.loaded);
    }
    function unsetBackgroundVideo(playerId) {
        $("#" + playerId)
            .removeAttr("style")
            .removeClass(classes.videoBackground)
            .addClass(classes.videoChrome);
        videos[playerId].$parentSlideshowWrapper.removeClass(classes.slideBackgroundVideo).addClass(classes.playing);
        videos[playerId].$parentSlide.removeClass(classes.slideBackgroundVideo).addClass(classes.playing);
        videos[playerId].status = "open";
    }
    function setBackgroundVideo(playerId) {
        var $player = $("#" + playerId)
            .addClass(classes.videoBackground)
            .removeClass(classes.videoChrome);
        videos[playerId].$parentSlide.addClass(classes.slideBackgroundVideo);
        videos[playerId].status = "background";
        sizeBackgroundVideo($player);
    }
    function initEvents() {
        $(document).on("click.videoPlayer", "." + classes.playVideoBtn, function (evt) {
            var playerId = $(evt.currentTarget).data("controls");
            startVideoOnClick(playerId);
        });
        $(document).on("click.videoPlayer", "." + classes.closeVideoBtn, function (evt) {
            var playerId = $(evt.currentTarget).data("controls");
            closeVideo(playerId);
        });
        $(window).on(
            "resize.videoPlayer",
            $.debounce(250, function () {
                if (youtubeLoaded) {
                    sizeBackgroundVideos();
                }
            })
        );
    }
    function removeEvents() {
        $(document).off(".videoPlayer");
        $(window).off(".videoPlayer");
    }
    return { init: init, loadVideos: loadVideos, loadVideo: loadVideo, playVideo: customPlayVideo, pauseVideo: pauseVideo, removeEvents: removeEvents };
})();
theme.slideshows = {};
theme.SlideshowSection = (function () {
    function SlideshowSection(container) {
        var $container = (this.$container = $(container));
        var sectionId = $container.attr("data-section-id");
        var slideshow = (this.slideshow = "#Slideshow-" + sectionId);
        $(".slideshow__video", slideshow).each(function () {
            var $el = $(this);
            theme.SlideshowVideo.init($el);
            theme.SlideshowVideo.loadVideo($el.attr("id"));
        });
        theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
    }
    return SlideshowSection;
})();
theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
    onUnload: function onUnload() {
        delete theme.slideshows[this.slideshow];
    },
    onBlockSelect: function onBlockSelect(evt) {
        var $slideshow = $(this.slideshow);
        var $slide = $(".slideshow__slide--" + evt.detail.blockId + ":not(.slick-cloned)");
        var slideIndex = $slide.data("slick-index");
        $slideshow.slick("slickGoTo", slideIndex).slick("slickPause");
    },
    onBlockDeselect: function onBlockDeselect() {
        $(this.slideshow).slick("slickPlay");
    },
});
window.theme = window.theme || {};
theme.Cart = (function () {
    var selectors = { edit: ".js-edit-toggle", giftMessage: "[js-gift-message]", giftMessageSave: "[js-save-gift-message]", giftMessageInput: "[js-gift-message-input]", giftMessageOpen: "[js-open-gift-message]" };
    var config = { showClass: "cart__update--show", showEditClass: "cart__edit--active", quantityInput: ".input-quantity", quantityInputWrapper: ".input-quantity--wrapper" };
    var cache = {};
    var _cacheSelectors = function _cacheSelectors() {
        cache = { $giftMessage: $(selectors.giftMessage), $giftMessageSave: $(selectors.giftMessageSave), $giftMessageInput: $(selectors.giftMessageInput), $giftMessageOpen: $(selectors.giftMessageOpen) };
    };
    var _bindEvents = function _bindEvents() {
        cache.$giftMessageOpen.on("click", _openGiftMessage);
        cache.$giftMessageSave.on("click", _saveGiftMessage);
        cache.$giftMessageInput.on("keypress", _resetGiftMessageSave);
    };
    $(document).on("AjaxCartModify", function (evt) {
        if (location.href.includes("cart")) {
            location.reload();
        }
    });
    function Cart(container) {
        this.$container = $(container);
        this.$edit = $(selectors.edit, this.$container);
        this.$edit.on("click", this._onEditClick.bind(this));
    }
    Cart.prototype = _.assignIn({}, Cart.prototype, {
        onUnload: function onUnload() {
            this.$edit.off("click", this._onEditClick);
        },
        _onEditClick: function _onEditClick(evt) {
            var $evtTarget = $(evt.target);
            var $updateLine = $("." + $evtTarget.data("target"));
            $evtTarget.toggleClass(config.showEditClass);
            $updateLine.toggleClass(config.showClass);
        },
    });
    function _resetGiftMessageSave() {
        cache.$giftMessageSave.text(theme.strings.giftMessageSave);
    }
    function _openGiftMessage() {
        cache.$giftMessage.addClass("cart-ajax__message--open");
        cache.$giftMessageInput.focus();
    }
    function _saveGiftMessage() {
        var message = cache.$giftMessageInput.val();
        $.ajax({
            type: "POST",
            url: "/cart.js",
            dataType: "json",
            data: { note: message },
            success: function success() {
                cache.$giftMessageSave.text(theme.strings.giftMessageSaved);
            },
            error: function error() {
                cache.$giftMessageSave.text(theme.strings.giftMessageError);
                setTimeout(function () {
                    cache.$giftMessageSave.text(theme.strings.giftMessageSave);
                }, 3000);
            },
        });
    }
    function init() {
        _cacheSelectors();
        _bindEvents();
    }
    return { init: init, Cart: Cart };
})();
theme.Cart.init();
window.theme = theme || {};
theme.customerTemplates = (function () {
    function initEventListeners() {
        $("#RecoverPassword").on("click", function (evt) {
            evt.preventDefault();
            toggleRecoverPasswordForm();
        });
        $("#HideRecoverPasswordLink").on("click", function (evt) {
            evt.preventDefault();
            toggleRecoverPasswordForm();
        });
    }
    function toggleRecoverPasswordForm() {
        $("#RecoverPasswordForm").toggleClass("hide");
        $("#CustomerLoginForm").toggleClass("hide");
    }
    function resetPasswordSuccess() {
        var $formState = $(".reset-password-success");
        if (!$formState.length) {
            return;
        }
        $("#ResetSuccess").removeClass("hide");
    }
  
    function checkUrlHash() {
        var hash = window.location.hash;
        if (hash === "#recover") {
            toggleRecoverPasswordForm();
        }
    }
    return {
        init: function init() {
            checkUrlHash();
            initEventListeners();
            resetPasswordSuccess();
        },
    };
})();
window.theme = window.theme || {};
theme.Product = (function () {
    function Product(container) {
        var $container = (this.$container = $(container));
        var sectionId = $container.attr("data-section-id");
        var $this = this;
        this.settings = {
            mediaQueryMediumUp: "screen and (min-width: 750px)",
            mediaQuerySmall: "screen and (max-width: 749px)",
            bpSmall: false,
            enableHistoryState: $container.data("enable-history-state") || false,
            imageZoomSize: null,
            namespace: ".slideshow-" + sectionId,
            sectionId: sectionId,
            sliderActive: false,
            zoomEnabled: false,
        };
        this.selectors = {
            addToCart: "#AddToCart-" + sectionId,
            addToCartText: "#AddToCartText-" + sectionId,
            comparePrice: "#ComparePrice-" + sectionId,
            originalPrice: "#ProductPrice-" + sectionId,
            SKU: ".variant-sku",
            originalPriceWrapper: ".product-price__price-" + sectionId,
            originalSelectorId: "#ProductSelect-" + sectionId,
            productFeaturedImage: "#FeaturedImage-" + sectionId,
            productPrices: ".product-single__price-" + sectionId,
            saleClasses: "product-price__sale product-price__sale--single",
            saleLabel: ".product-price__sale-label-" + sectionId,
            singleOptionSelectorBase: ".single-option-selector",
            singleOptionSelector: ".single-option-selector-" + sectionId,
            productForm: ".product-form-" + sectionId,
            cartBody: ".cart-ajax",
            cartRow: ".cart-ajax__row",
            productTabs: ".product-tabs__tab",
            productTabsHead: ".product-tabs__head",
            productTabsBody: ".product-tabs__body",
            feefoTab: ".product-tabs__body-feefo",
            feefoMain: ".feefo-review-widget-product",
            feefoEmpty: ".feefo-no-reviews",
        };
        if (!$("#ProductJson-" + sectionId).html()) {
            return;
        }
        this.productSingleObject = JSON.parse(document.getElementById("ProductJson-" + sectionId).innerHTML);
        this._stringOverrides();
        this._initVariants();
        $(this.selectors.productTabsHead).on("click", function () {
            if ($(this).parent().find(".product-tabs__body-feefo").length > 0) {
                $(this).parent().toggleClass("product-tabs__tab--active");
                $this.feefoWidgetsToggle();
            } else {
                $(this).parent().toggleClass("product-tabs__tab--active");
                $(this).parent().find(".product-tabs__body").slideToggle();
            }
        });
    }
    Product.prototype = _.assignIn({}, Product.prototype, {
        _stringOverrides: function _stringOverrides() {
            theme.productStrings = theme.productStrings || {};
            $.extend(theme.strings, theme.productStrings);
        },
        feefoWidgetsToggle: function feefoWidgetsToggle() {
            var feefoTab = $(this.selectors.feefoTab);
            if (feefoTab.hasClass("feefo-show")) {
                feefoTab.find(".product-tabs__content").slideToggle("slow", function () {
                    feefoTab.removeClass("feefo-show");
                });
            } else {
                $(this.selectors.feefoMain).show();
                feefoTab.addClass("feefo-show");
                feefoTab.find(".product-tabs__content").slideToggle("slow");
            }
        },
        _initVariants: function _initVariants() {
            var options = {
                $container: this.$container,
                enableHistoryState: this.$container.data("enable-history-state") || false,
                singleOptionSelector: this.selectors.singleOptionSelector,
                productForm: this.selectors.productForm,
                cartBody: this.selectors.cartBody,
                originalSelectorId: this.selectors.originalSelectorId,
                product: this.productSingleObject,
            };
            this.variants = new slate.Variants(options);
            $(document).on("quantityChanged" + this.settings.namespace, this._updateAddToCart.bind(this));
            this.$container.on("variantChange AjaxAddToCart quantityChanged" + this.settings.namespace, this._updateAddToCart.bind(this));
            this.$container.on("variantSwatchUpdate" + this.settings.namespace, this._updateSwatches.bind(this));
            this.$container.on("variantImageChange" + this.settings.namespace, this._updateImages.bind(this));
            this.$container.on("variantPriceChange" + this.settings.namespace, this._updatePrice.bind(this));
            this.$container.on("variantSKUChange" + this.settings.namespace, this._updateSKU.bind(this));
            this.$container.on("formSubmit" + this.settings.namespace, this._ajaxCartAddtoCart.bind(this));
        },
        _updateSwatches: function _updateSwatches(evt) {
            var variant = evt.variant;
        },
        _updateAddToCart: function _updateAddToCart(evt) {
            var variant = evt.variant;
            var $addToCartBtnText = $(this.selectors.addToCartText),
                $addToCartBtn = $(this.selectors.addToCart);
            if (evt.type == "AjaxAddToCart") {
                $(this.selectors.productPrices).removeClass("visibility-hidden").attr("aria-hidden", "true");
                var response = evt.response.responseJSON == undefined ? evt.response : evt.response.responseJSON;
                if (response.status == 404) {
                    if (response.description == "Cannot find variant") {
                        $addToCartBtn.prop("disabled", true);
                        $addToCartBtnText.text(theme.strings.unavailable);
                    }
                } else if (response.status == 422) {
                    $addToCartBtn.prop("disabled", true);
                    $addToCartBtnText.text(theme.strings.addToCartFull);
                } else {
                    $addToCartBtn.prop("disabled", false).addClass("product-form--submitted");
                    $addToCartBtnText.text(theme.strings.addToCartSuccess);
                    setTimeout(function () {
                        $addToCartBtnText.text(theme.strings.addToCart);
                        $addToCartBtn.prop("disabled", false).removeClass("product-form--submitted");
                    }, 700);
                }
            } else if (evt.type == "quantityChanged") {
                if ($(this.selectors.addToCartText).text() != theme.strings.unavailable) {
                    $(this.selectors.productPrices).removeClass("visibility-hidden").attr("aria-hidden", "true");
                    $(this.selectors.addToCart).prop("disabled", false);
                    $(this.selectors.addToCartText).text(theme.strings.addToCart);
                }
            } else {
                if (variant) {
                    $(this.selectors.productPrices).removeClass("visibility-hidden").attr("aria-hidden", "true");
                    if (variant.available) {
                        $(this.selectors.addToCart).prop("disabled", false);
                        $(this.selectors.addToCartText).text(theme.strings.addToCart);
                    } else {
                        $(this.selectors.addToCart).prop("disabled", true);
                        $(this.selectors.addToCartText).text(theme.strings.soldOut);
                    }
                } else {
                    $(this.selectors.addToCart).prop("disabled", true);
                    $(this.selectors.addToCartText).text(theme.strings.unavailable);
                    $(this.selectors.productPrices).addClass("visibility-hidden").attr("aria-hidden", "false");
                }
            }
        },
        _updateImages: function _updateImages(evt) {
            var newImage = evt.newVariantImage.src;
            var currentImage = evt.currentVariantImage.src;
            $(this.selectors.productFeaturedImage).prop("src", newImage);
        },
        _updatePrice: function _updatePrice(evt) {
            var variant = evt.variant;
            $(this.selectors.originalPrice).html(theme.Currency.formatMoney(variant.price, currencyFormat.shopifyMoneyFormat));
            if (variant.compare_at_price > variant.price) {
                $(this.selectors.comparePrice).html(theme.Currency.formatMoney(variant.compare_at_price, currencyFormat.shopifyMoneyFormat)).removeClass("hide");
                $(this.selectors.originalPriceWrapper).addClass(this.selectors.saleClasses);
                $(this.selectors.saleLabel).removeClass("hide");
            } else {
                $(this.selectors.comparePrice).addClass("hide");
                $(this.selectors.saleLabel).addClass("hide");
                $(this.selectors.originalPriceWrapper).removeClass(this.selectors.saleClasses);
            }
            $(document).trigger("updateCurrencies");
        },
        _updateSKU: function _updateSKU(evt) {
            var variant = evt.variant;
            $(this.selectors.SKU).html(variant.sku);
        },
        _ajaxCartAddtoCart: function _ajaxCartAddtoCart(evt) {
            var formData = $(evt.target).serialize();
            var $self = this;
            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: formData,
                dataType: "json",
                success: function success(cartData) {
                    $($self.$container).trigger({ type: "AjaxAddToCart", response: cartData }).trigger({ type: "AjaxCartRequest", response: cartData });
                },
                error: function error(request, status) {
                    $self.$container.trigger({ type: "AjaxAddToCart", response: request });
                },
            });
        },
        onUnload: function onUnload() {
            this.$container.off(this.settings.namespace);
        },
    });
    return Product;
})();
$(".product-usp__value").each(function () {
    if ($(this).hasClass("2-up")) {
        $(this).parent(".product-usp__flex").addClass("icon-counter_2");
    }
});
$(document).on("click", ".product-single__header .feefo-review-badge-wrapper-product", function () {
    var $tab = $(".product-tabs__body-feefo").closest(".product-tabs__tab");
    $("html, body").animate({ scrollTop: $tab.offset().top - 70 }, 1000);
    if (!$tab.hasClass("product-tabs__tab--active")) {
        $tab.find(".product-tabs__head").trigger("click");
    }
});
slate.Variants = (function () {
    function Variants(options) {
        this.$container = options.$container;
        this.product = options.product;
        this.productForm = options.productForm;
        this.singleOptionSelector = options.singleOptionSelector;
        this.originalSelectorId = options.originalSelectorId;
        this.enableHistoryState = options.enableHistoryState;
        this.currentVariant = this._getVariantFromOptions();
        this.updateSelectors = ".cart-ajax__quantity-increment, .cart-ajax__remove";
        this.quantitySelector = ".product-form__quantity-increment, .cart-ajax__quantity-increment";
        $(this.singleOptionSelector).on("change", this._onSelectChange.bind(this));
        $(this.productForm).ready(this._onSwatchLoad.bind(this));
        $(this.productForm).on("submit", this._onFormSubmit.bind(this));
    }
    Variants.prototype = _.assignIn({}, Variants.prototype, {
        _getCurrentOptions: function _getCurrentOptions() {
            var currentOptions = _.map($(this.singleOptionSelector, this.$container), function (element) {
                var $element = $(element);
                var type = $element.attr("type");
                var currentOption = {};
                if (type === "radio" || type === "checkbox") {
                    if ($element[0].checked) {
                        currentOption.value = $element.val();
                        currentOption.index = $element.data("index");
                        return currentOption;
                    } else {
                        return false;
                    }
                } else {
                    currentOption.value = $element.val();
                    currentOption.index = $element.data("index");
                    return currentOption;
                }
            });
            currentOptions = _.compact(currentOptions);
            return currentOptions;
        },
        _getVariantFromOptions: function _getVariantFromOptions() {
            var selectedValues = this._getCurrentOptions();
            var variants = this.product.variants;
            var found = _.find(variants, function (variant) {
                return selectedValues.every(function (values) {
                    return _.isEqual(variant[values.index], values.value);
                });
            });
            return found;
        },
        _onFormSubmit: function _onFormSubmit(evt) {
            evt.preventDefault();
            this.$container.trigger({ type: "formSubmit", target: evt.currentTarget });
        },
        _onSwatchLoad: function _onSwatchLoad(evt) {
            var radio = $(".single-option-selector:checked");
            radio.each(function () {
                var id = $(this).attr("id");
                $(".single-option").each(function () {
                    if ($(this).attr("for") === id) {
                        $(this).addClass("single-option--selected");
                    }
                });
            });
        },
        _onSelectChange: function _onSelectChange(event) {
            var $this = event.target;
            var $form = $($this).closest("form");
            var id = $(event.target).attr("id");
            var option = id.split("_")[1];
            var option_2 = id.split("--")[1];
            var option_3 = option + option_2;
            var label = $("label.single-option[for=" + id + "]");
            var selected = $(".single-option--selected");
            $($form)
                .find(".single-option--selected")
                .each(function () {
                    var this_option = $(this).attr("for").split("_")[1];
                    var this_option_2 = $(this).attr("for").split("--")[1];
                    var this_option_3 = this_option + this_option_2;
                    if (this_option_3 === option_3) {
                        $(this).removeClass("single-option--selected");
                    }
                });
            label.addClass("single-option--selected");
            if ($(event.target).data("index") === "option1") {
                var available_options = $(event.target).data("option-values");
                var visible_options = 0;
                $($form)
                    .find(".single-option-selector[data-index=option2]")
                    .each(function () {
                        var label = $("label.single-option[for=" + $(this).attr("id") + "]");
                        if (available_options.indexOf($(this).data("value-handle")) == -1) {
                            label.addClass("single-option--hidden");
                            label.removeClass("single-option--visible");
                        } else {
                            label.removeClass("single-option--hidden");
                            label.addClass("single-option--visible");
                            visible_options++;
                        }
                    });
                if (!$(".single-option--selected").hasClass("single-option--visible")) {
                    $(".single-option--visible").first().trigger("click");
                }
            }
            var variant = this._getVariantFromOptions();
            this.$container.trigger({ type: "variantChange", variant: variant });
            if (!variant) {
                return;
            }
            this._updateMasterSelect(variant);
            this._updatePrice(variant);
            this._updateSKU(variant);
            this._updateSwatches(variant);
            this.currentVariant = variant;
            if (this.enableHistoryState) {
                this._updateHistoryState(variant);
            }
        },
        _updateImages: function _updateImages(variant) {
            var variantImage = variant.featured_image || {};
            var currentVariantImage = this.currentVariant.featured_image || {};
            if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
                return;
            }
            this.$container.trigger({ type: "variantImageChange", currentVariantImage: currentVariantImage, newVariantImage: variantImage });
        },
        _updatePrice: function _updatePrice(variant) {
            if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
                return;
            }
            this.$container.trigger({ type: "variantPriceChange", variant: variant });
        },
        _updateSKU: function _updateSKU(variant) {
            if (variant.sku === this.currentVariant.sku) {
                return;
            }
            this.$container.trigger({ type: "variantSKUChange", variant: variant });
        },
        _updateSwatches: function _updateSwatches(variant) {
            this.$container.trigger({ type: "variantSwatchUpdate", variant: variant });
        },
        _updateHistoryState: function _updateHistoryState(variant) {
            if (!history.replaceState || !variant) {
                return;
            }
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + variant.id;
            window.history.replaceState({ path: newurl }, "", newurl);
        },
        _updateMasterSelect: function _updateMasterSelect(variant) {
            $(this.originalSelectorId, this.$container).val(variant.id);
        },
    });
    return Variants;
})();
window.theme = window.theme || {};
theme.HeaderSection = (function () {
    $(document).ready(function () {
        theme.MobileNav.init();
        theme.Search.init();
        theme.Quantity.init();
        theme.QuickAdd.init();
    });
    setTimeout(function () {
        theme.ajaxCart.init();
    }, 1000);
})();
$(document).ready(function () {
    var sections = new theme.Sections();
    sections.register("header-section", theme.HeaderSection);
    sections.register("collection-template", theme.Filters);
    sections.register("collection-template", theme.quickview);
    sections.register("product-template", theme.Product);
    sections.register("product", theme.Product);
    sections.register("cart-template", theme.Cart);
    sections.register("modal", theme.NewsletterPopup);
    sections.register("modal", theme.ExitIntent);
    sections.register("map", theme.Maps);
    sections.register("quotes", theme.Quotes);
    sections.register("slideshow-section", theme.SlideshowSection);
});
theme.init = function () {
    var $headerWrapper = $(".site-header--wrapper");
    var $header = $(".site-header");
    var $notification = $(".notification-bar");
    var $mobileNavWrapper = $(".mobile-nav-wrapper");
    theme.customerTemplates.init();
    slate.rte.wrapTable();
    slate.rte.iframeReset();
    slate.a11y.pageLinkFocus($(window.location.hash));
    $(".in-page-link").on("click", function (evt) {
        slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });
    $('a[href="#"]').on("click", function (evt) {
        evt.preventDefault();
    });
    $(".site-nav--has-dropdown").on("mouseenter mouseleave", function () {
        $headerWrapper.toggleClass("site-header--hover");
        $(this).find(".site-nav__dropdown").toggleClass("site-nav__dropdown--active");
        setTimeout(function () {
            if ($(".site-nav__dropdown").hasClass("site-nav__dropdown--active")) {
                $(".site-nav__dropdown").addClass("site-nav__dropdown--active--notransition");
            } else {
                $(".site-nav__dropdown").removeClass("site-nav__dropdown--active--notransition");
            }
        }, 300);
    });
    $(".site-header").on("mouseleave", function () {
        if ($(".site-nav__dropdown").hasClass("site-nav__dropdown--active--notransition")) {
            $(".site-nav__dropdown").removeClass("site-nav__dropdown--active--notransition");
        }
    });
    $(".site-nav--has-dropdown > a, .site-nav__level-link > a").on("touchstart", function (event) {
        event.preventDefault();
        $header.addClass("site-header--hover site-header--hover-opacity site-header--text-color");
        var link = $(this);
        var link_url = link.attr("href");
        var is_second_click = false;
        if (link.data("touch") === 1) {
            link.attr("data-touch", 2);
            is_second_click = true;
        } else {
            link.parent().siblings().find("a").removeAttr("data-touch");
            link.attr("data-touch", 1);
        }
        if (is_second_click === false) {
            if ($(this).parent().hasClass("site-nav--has-dropdown")) {
                $(".site-nav__dropdown--active").removeClass("site-nav__dropdown--active");
                link.closest(".site-nav--has-dropdown").find(".site-nav__dropdown").toggleClass("site-nav__dropdown--active");
                $headerWrapper.toggleClass("site-header--hover");
            } else {
                thirdLevelNav(link);
            }
        }
        if (is_second_click === true) {
            window.location.href = link_url;
        }
        $(document).on("click", function (e) {
            var $target = $(e.target);
            if (!$target.closest(".site-nav__dropdown").length) {
                $(".site-nav__dropdown").removeClass("site-nav__dropdown--active");
                $(".site-header--wrapper").removeClass("site-header--hover");
            }
        });
    });
    function thirdLevelNav(link) {
        var data_type = link.attr("data-handle");
        var $third_level_nav = $('.site-nav__sub-nav[data-handle="' + data_type + '"]');
        if (link.parents(".site-nav__level").hasClass("site-nav__level--2") && $third_level_nav.length) {
            $(".site-nav__sub-nav--active, .site-nav__level-link--hover").removeClass("site-nav__sub-nav--active site-nav__level-link--hover");
            $('.site-nav__sub-nav[data-handle="' + data_type + '"]').addClass("site-nav__sub-nav--active");
            link.parent().addClass("site-nav__level-link--hover");
        } else {
            window.location.href = link.attr("href");
        }
    }
// Loop through all level-2 menu links and apply hover behavior by default
$(".site-nav__level--2 li a").each(function () {
    var $link = $(this);
    var sub = $link.data("handle");

    // Activate the corresponding sub-nav
    $(".site-nav__sub-nav[data-handle='" + sub + "']").addClass("site-nav__sub-nav--active");

    // Apply hover-like visual classes
    $link.closest(".site-nav__level").addClass("site-nav__level--hover");
    $link.closest(".site-nav__level-link").addClass("site-nav__level-link--hover");
});
    $("select").not(".no-js").selectric();
    var lastScrollTop = 0;
    $(window).on("scroll resize", function () {
        var scrollTop = $(window).scrollTop();
        var st = window.pageYOffset || document.documentElement.scrollTop;
        if (window.matchMedia("(min-width: 767px)").matches) {
            if (st > lastScrollTop && scrollTop > 400) {
                $(".site-header--wrapper").addClass("site-header--going-up");
                $(".site-header--wrapper").removeClass("site-header--wrapper--visible");
            } else {
                $(".site-header--wrapper").removeClass("site-header--going-up");
                $(".site-header--wrapper").addClass("site-header--wrapper--visible");
            }
        } else {
            if (scrollTop > 400) {
                $(".site-header--wrapper").addClass("site-header--going-up--mobile");
                $(".site-header--wrapper").removeClass("site-header--wrapper--visible--mobile");
            } else {
                $(".site-header--wrapper").removeClass("site-header--going-up--mobile");
                $(".site-header--wrapper").addClass("site-header--wrapper--visible--mobile");
            }
        }
        lastScrollTop = st == 0 ? 0 : st;
    });
    $(window).on("scroll resize", function () {
        var scrollTop = $(window).scrollTop();
        if (scrollTop > 400) {
            $headerWrapper.addClass("site-header--animate");
            $header.addClass("site-header--opacity");
            $header.removeClass("site-header--text-color");
            theme.ajaxCart.updateAjaxCartHeight();
        } else {
            $header.removeClass("site-header--opacity");
            $headerWrapper.removeClass("site-header--animate");
            theme.ajaxCart.updateAjaxCartHeight();
        }
    });
    $(window).on(
        "resize",
        $.debounce(100, function () {
            $("body").css("padding-top", $header.height());
        })
    );
    $header.addClass("site-header--text-color");
    $($header).hover(function () {
        if (!$mobileNavWrapper.hasClass("js-menu--is-open")) {
            $header.toggleClass("site-header--hover-opacity");
            $header.toggleClass("site-header--text-color");
        }
    });
    $(document).ready(function () {
        $("body").css("padding-top", $header.height());
        $("body").addClass("loaded");
        window.scrollTo(0, 0);
    });
};
$(theme.init);
AOS.init({ disable: "mobile" });
$(window).on("load", function () {
    AOS.refresh();
});


function removeGroup(groupId, variantId) {
  
  	$('.cart-ajax__tools .text-center a.btn').css('pointer-events', 'none');
  	$('input[name="checkout"]').prop('disabled', true);
  
    $.getJSON('/cart.js', function (data) {

        var postUrlParams = ''; 

        data.items.forEach(function(item, index) {
            if ((item.properties) && (item.properties['group_id']) && (item.properties['group_id'] == groupId)) {
                postUrlParams += 'updates[' + item.key + ']=0';
                if (index < (data.items.length - 1)) {
                  postUrlParams += '&';
                }
            }
        });
        $.post('/cart/update.js', postUrlParams, function() {}, 'json').done(function() {
            location.reload();
        });
    });
}

